function isValidDate(d: Date) {
  return !isNaN(d.getTime());
}

export default isValidDate;
